import React from 'react';

import { UiComponent } from 'components';
import useModal from 'hooks/useModal';
import { IQuickMenu } from 'types';
import * as PickerStyle from 'components/userGroup/Picker/style';
import UserGroupPicker from './UserGroupPicker';
import * as FormStyle from './style';

type GroupType = IQuickMenu['userGroups'][number];

interface Props {
  selected: GroupType[];
  onChange: (groups: GroupType[]) => void;
}

// 서버는 여러 그룹을 받지만 지금은 한 그룹만 고르게 한다
function UserGroupSelect({ selected, onChange }: Props) {
  const { handleModal } = useModal();
  const [group] = selected;

  const openPicker = () =>
    handleModal(
      '회원 그룹 선택',
      <UserGroupPicker
        selectedId={group?.id}
        onSelect={(picked) => onChange([picked])}
      />,
      <></>,
    );

  return (
    <div css={PickerStyle.selectedEvent}>
      {group ? (
        <span>
          <strong>{group.name}</strong>
        </span>
      ) : (
        <span css={FormStyle.hint}>선택된 회원 그룹이 없습니다</span>
      )}
      <div css={FormStyle.groupActions}>
        {group && (
          <UiComponent.Button
            variant="border"
            color="grey"
            onClick={() => onChange([])}
          >
            해제
          </UiComponent.Button>
        )}
        <UiComponent.Button
          variant="border"
          color="primary"
          onClick={openPicker}
        >
          {group ? '그룹 변경' : '그룹 선택'}
        </UiComponent.Button>
      </div>
    </div>
  );
}

export default UserGroupSelect;
